import {Routes, RouterModule} from '@angular/router';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {LoginComponent} from './login/login.component';
import {UserPageComponent} from './user-page/user-page.component';
import {ServerComponent} from './server/server.component';
import {RoleGuardService} from './role-guard.service';
import {ServerEditComponent} from './server/server-edit/server-edit.component';
import {CustomerComponent} from './customer/customer.component';
import {CustomerEditComponent} from './customer/customer-edit/customer-edit.component';
import {UserComponent} from './user/user.component';
import {UserEditComponent} from './user/user-edit/user-edit.component';
import {WebDialerComponent} from './web-dialer/web-dialer.component';
import {ChangePassComponent} from './change-pass/change-pass.component';
import {BillingDashboardComponent} from './billing-dashboard/billing-dashboard.component';
import {CostCenterComponent} from './cost-center/cost-center.component';
import {CostCenterEditComponent} from './cost-center/cost-center-edit/cost-center-edit.component';
import {DepartmentEditComponent} from './department/department-edit/department-edit.component';
import {DepartmentComponent} from './department/department.component';
import {ExtensionComponent} from './extension/extension/extension.component';
import {ExtensionEditComponent} from './extension/extension-edit/extension-edit.component';
import {TariffClassComponent} from './tariff-class/tariff-class.component';
import {TariffClassEditComponent} from './tariff-class/tariff-class-edit/tariff-class-edit.component';
import {DetailedCallsComponent} from './billing/detailed-calls/detailed-calls.component';


const appRoutes: Routes = [

  {
    path: '',
    redirectTo: '/webdialer',
    pathMatch: 'full'
  },
  {path: 'login', component: LoginComponent},
  {
    path: 'user_page', component: UserPageComponent, canActivate: [RoleGuardService],
    data: {roles: ['ANY']}
  },
  {
    path: 'servers', component: ServerComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT']}
  },
  {
    path: 'servers/:id', component: ServerEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT']}
  },
  {
    path: 'servers_new', component: ServerEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT']}
  },
  {
    path: 'customers', component: CustomerComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT']}
  },
  {
    path: 'customers/:id', component: CustomerEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT']}
  },
  {
    path: 'customers_new', component: CustomerEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT']}
  },
  {
    path: 'users', component: UserComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'users/:id', component: UserEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'users_new', component: UserEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'webdialer', component: WebDialerComponent, canActivate: [RoleGuardService],
    data: {roles: ['WEB_DIALER']}
  },
  {
    path: 'changePass', component: ChangePassComponent, canActivate: [RoleGuardService],
    data: {roles: ['ANY']}
  },
  {
    path: 'billing_dashboard', component: BillingDashboardComponent, canActivate: [RoleGuardService],
    data: {roles: ['ANY']}
  },
  {
    path: 'cost_centers', component: CostCenterComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'cost_centers/:id', component: CostCenterEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'cost_centers_new', component: CostCenterEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'departments', component: DepartmentComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'departments/:id', component: DepartmentEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'departments_new', component: DepartmentEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'extensions', component: ExtensionComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'extensions/:id', component: ExtensionEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'extensions_new', component: ExtensionEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'tariff_class', component: TariffClassComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'tariff_class/:id', component: TariffClassEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'tariff_class_new', component: TariffClassEditComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {
    path: 'billing/detailed', component: DetailedCallsComponent, canActivate: [RoleGuardService],
    data: {roles: ['ROOT', 'USER_ADMIN']}
  },
  {path: '**', component: PageNotFoundComponent},
];


export const appRoutingProviders: any = [];

export const routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/app.routing.ts